/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCrumbSegukids from 'components/BreadCrumbMex/BreadCrumbSegukids';
import { BaseButton } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import { urlDataPlanes, urlNumHijos, urlPlanSelected, urlcrearPolizaSKT } from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import useUsuario from 'hooks/useUsuario';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import COLORS from 'utils/constants/COLORS';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import imgDownload from '../../assets/img/mex/planes/download.svg';
import MessageMia from './MessageMia';
import Plan from './Plan';

const PlanPagoKids = ({ qParams }) => {
  const { idCotizacion } = qParams;

  const [loading, setLoading] = useState(false);

  const history = useCustomRouter();

  const { userIsLoggedIn, cliCodigoCore } = useUsuario();

  const [planes, setPlanes] = useState([]);

  const [showInteres, setShowInteres] = useState(false);

  const { setCombos, parametros, fetchParametros, ...stateParametrosPago } = useParametrosPago(PRODUCTOS.SEGUKIDS);

  const [tipoPago, setTipoPago] = useState([]);

  const [idPaquete, setIdPaquete] = useState();

  const [planID, setPlanID] = useState();

  const [planUID, setPlanUID] = useState();

  const [meses, setMeses] = useState([]);

  const [pagoSelect, setPagoSelect] = useState(null);

  const [loadingResumen, setLoadingResumen] = useState(false);

  const [nombres, setNombres] = useState('');

  const [numChild, setnumChild] = useState();

  const numberChild = async () => {
    setLoading(true);
    setLoadingResumen(true);
    const dataChild = await ApiKeyFetch.instance().post(urlNumHijos, {
      idCotizacion: idCotizacion,
    });
    if (dataChild.transaccion === true) {
      let hijo = dataChild.data?.catalogo?.numHijos;
      setnumChild(hijo);
      getDataPlan(hijo);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchParametros();
  }, []);

  useEffect(() => {
    if (stateParametrosPago.loading === false && parametros?.formasPago && loadingResumen === false) {
      numberChild();
    }
  }, [parametros?.formasPago, stateParametrosPago.error, stateParametrosPago.loading, loadingResumen]);

  const selectIntereses = (pago) => {
    setMeses(pago.option);
    setPagoSelect(pago);
    setShowInteres(true);
  };

  const getDataPlan = async (hijos) => {
    setLoading(true);
    setLoadingResumen(true);
    var cardPago = [];

    const promises = parametros?.formasPago?.map((forma) => {
      const body = {
        idCotizacion: idCotizacion,
        nombrecatalogo: 'planes',
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
          codigoAgente: 77657,
        },
        numHijos: hijos,
        formasDePago: {
          idPlazo: forma.value.id,
          tipo: forma.value.tipo,
          label: forma.label,
        },
        pasoCodigo: 'planSeleccionado',
        tarifarPlanSeleccionado: true,
      };
      return ApiKeyFetch.instance().post(urlDataPlanes, body);
    });

    const responses = await Promise.all(promises);

    responses.forEach((resResumen, i) => {
      if (resResumen.transaccion === true) {
        setNombres(resResumen.data.catalogo.datosContratante.usuNombre.split(' ')[0]);
        resResumen.data.catalogo.paquetes.map((item) => {
          setPlanes(item.planes);
          setIdPaquete(item.id);
          item.planes.map((data) => {
            setPlanID(data.id);
            setPlanUID(data.uid);
            cardPago.push({
              primaAnual: data.precioFormatoAnual,
              primaMensual: data.precioMensual,
              tipo: parametros.formasPago[i].label,
              urlPdf: data.urlPdfCotizacion,
              idPlazo: parametros.formasPago[i].value.id,
              tipoP: parametros.formasPago[i].value.tipo,
              option: parametros.formasPago[i]?.value.options,
              nota: data.notaFormaPago,
            });
          });
        });
      }
    });

    setTipoPago(cardPago);
    setLoading(false);
  };

  const selectPago = async (pago, interes) => {
    if (pago.tipo === 'MESES SIN INTERESES' && !interes) {
      selectIntereses(pago);
    } else {
      let pagos = {
        idPlazo: interes ? interes.value.ID : pago.idPlazo,
        tipo: pago.tipoP,
        label: interes ? interes.value.label : pago.tipo,
      };
      let agenteValue = null;
      if (!userIsLoggedIn) {
        agenteValue = 77657;
      } else {
        agenteValue = 77657;
      }
      try {
        let body = {
          usuCotiza: {
            usuCodigo: cliCodigoCore || '',
            codigoAgente: agenteValue,
          },
          idCotizacion: idCotizacion,
          nombrecatalogo: 'planes',
          planSeleccionado: {
            paqueteID: idPaquete,
            planID: planID,
            PlanUID: planUID,
          },
          formasDePago: pagos,
          numHijos: 1,
          pasoCodigo: 'planSeleccionado',
          tarifarPlanSeleccionado: false,
        };
        const response = await ApiKeyFetch.instance().post(urlPlanSelected, body);

        if (response.transaccion === true) {
          let content = {
            idCotizacion: idCotizacion,
          };
          const polizaSKT = await ApiKeyFetch.instance().post(urlcrearPolizaSKT, content);

          if (polizaSKT.transaccion === true) {
            let poliza = polizaSKT.data.idPoliza;

            //history.push(`/kids/pagador?idPoliza=${poliza}&codProducto=SKT`);
            history.push(`/facturacion/tipo-persona?idPoliza=${poliza}&codProducto=SKT`);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const onClickAtras = () => {
    history.push(`/kids/planes?idCotizacion=${idCotizacion}`);
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <Page>
          <BreadCrumbSegukids
            {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[3]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
            showImg={false}
            showImgTitle={true}
            subtitleClassnames={'col-md-12'}
          />

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <MessageMia
                  textMessage={
                    '¡Muy bien ' + nombres + '!, ahora elije la forma de pago que más se acomoda a tus necesidades.'
                  }
                ></MessageMia>
              </div>
            </div>
            <div className="border mb-5">
              <div className="row mt-5">
                <div className="col-md-8 mb-4 offset-md-4">
                  <h2 className="text-mex">Selecciona la forma de pago</h2>
                </div>
              </div>
              <div className="row mt-2 mb-4 mx-4">
                {planes.map((item, index) => (
                  <div className="col-lg-4 col-12" key={index}>
                    <Plan plan={item} showBtnDescarga={false} showHeader={false} showContratar={false} />
                  </div>
                ))}
                <div className="col-lg-8 col-12">
                  <div className="row d-flex">
                    {tipoPago.map((pago, index) => (
                      <div className="col-lg-4  col-12" key={index}>
                        <div
                          className="cardTipo"
                          onClick={() => {
                            selectPago(pago, null);
                          }}
                        >
                          <div>
                            <div className="card-content">
                              <div className="text-center text-blue pt-20 head-title-pago ">
                                {pago?.tipo === 'CONTADO' ? 'PRIMA ANUAL' : 'PRIMA ' + pago?.tipo}
                              </div>
                              {}
                              <div className="text-center header-prima">{'$' + pago.primaMensual + ' MXN'}</div>
                              <div className="text-center header-subtitle mt-1">
                                <span>Prima total anual</span>
                                <Badge
                                  pill
                                  variant="success"
                                  className="blueLight rounded-pill ml-1"
                                  style={{ fontSize: '13px' }}
                                >
                                  {numChild}
                                </Badge>
                                <span className="ml-1">hijo/s</span>
                              </div>
                              <div className="text-center">
                                <p className="txt_desde">{'$' + pago.primaAnual}</p>
                              </div>
                            </div>
                            <div className="text-center">
                              <img src={imgDownload} alt="Descarga" />
                              <a
                                href={pago.urlPdf}
                                target="blank"
                                className=" ml-2 indexskt"
                                onClick={(e) => e.stopPropagation()}
                              >
                                Descargar cotización
                              </a>
                            </div>

                            <div style={{ padding: '10px' }} className="d-flex">
                              <p className="notaPago">
                                {' '}
                                <span>Nota:</span>
                                {pago.nota}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <>
                      {showInteres && (
                        <div className="col-lg-4 col-12">
                          <div className="cardMSI">
                            <div className="row justify-content-center">
                              <div className="col-md-12 text-center mb-0">
                                {/*  <span className="">Seleccione:</span>  */}
                              </div>

                              {meses.map((interes, index) => (
                                <div
                                  className="content-pago text-center pt-20 text-blue"
                                  onClick={() => selectPago(pagoSelect, interes)}
                                  key={index}
                                >
                                  {interes.value.Name.split(' ')[0]}
                                  <div className="header-subtitle">Meses sin interses</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 offset-md-4 mb-5">
                  <BaseButton onClick={onClickAtras} type="button" textColor="white" bgColor={COLORS.primary}>
                    <i
                      className="pi pi-arrow-left"
                      style={{
                        position: 'relative',
                        top: '1px',
                        fontSize: '1.4rem',
                      }}
                    />{' '}
                    Atrás
                  </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </Loading>
    </React.Fragment>
  );
};

export default PlanPagoKids;
